module.exports = __webpack_public_path__ + "static/media/Linkedin.becd3ceb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/UnifiedMessaging/Linkedin.svg
// module id = 1845
// module chunks = 0